import { createFileRoute } from "@tanstack/react-router";
import { pageTitle } from "@/components/document-title";
import { VblMapPage } from "@/features/vehicle-base-locations/components/vbl-map-page/vbl-map-page";

export const Route = createFileRoute(
	"/_authenticated/admin/vehicle-base-locations"
)({
	head: () => pageTitle("Base Locations"),
	component: VblMapPage,
});
